import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'melp-design/components';
import { FileDownloadOutlined } from '@mui/icons-material';

interface Props {
  listLength: number;
  loading: boolean;
  exportToExcel: () => void;
}

export const DownloadXlsAction: FC<Props> = ({
  exportToExcel,
  loading,
  listLength,
}) => {
  const { t } = useTranslation();
  const handleDownload = useCallback(() => {
    exportToExcel();
  }, [exportToExcel]);

  return (
    <Button
      label={t('dashboard.download_xls')}
      size="sm"
      variant="neutral-outline"
      icon={FileDownloadOutlined}
      onClick={handleDownload}
      disabled={!listLength || loading}
    />
  );
};
